module.exports = __webpack_public_path__ + "07_mole.328c9d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/07_mole.png
// module id = LdbQ
// module chunks = 0